import { render, staticRenderFns } from "./Nsc.vue?vue&type=template&id=65d29dcb&scoped=true"
import script from "./Nsc.vue?vue&type=script&lang=js"
export * from "./Nsc.vue?vue&type=script&lang=js"
import style0 from "./Nsc.vue?vue&type=style&index=0&id=65d29dcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d29dcb",
  null
  
)

export default component.exports